var exports = {
  "k": "x2b2fbebb--34e16a--container",
  "x": "x2b2fbebb--34e16a--button",
};

module.exports = exports;
